"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importStar(require("styled-components"));
var usePreventBodyScroll_1 = __importDefault(require("./hooks/usePreventBodyScroll"));
var useCalculateZoom_1 = __importDefault(require("./hooks/useCalculateZoom"));
var useZoomPosition_1 = __importDefault(require("./hooks/useZoomPosition"));
var useImageLoader_1 = __importDefault(require("./hooks/useImageLoader"));
var rotate = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n"], ["\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n"])));
var Figure = styled_components_1.default.figure(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  width: auto;\n  min-height: ", ";\n  background-position: 50% 50%;\n  background-color: #eee;\n  margin: 0;\n  overflow: hidden;\n  cursor: ", ";\n  user-select: none;\n\n  &:before {\n    content: \"\";\n    background-color: transparent;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ", ";\n    transition: opacity 0.2s ease-in-out;\n    z-index: 1;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: calc(50% - 25px);\n    left: calc(50% - 25px);\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    border: 5px solid transparent;\n    border-top-color: #333;\n    border-right-color: #333;\n    border-bottom-color: #333;\n    animation: ", " 2s linear infinite;\n    opacity: ", ";\n    transition: opacity 0.2s ease-in-out;\n    z-index: 2;\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  width: auto;\n  min-height: ", ";\n  background-position: 50% 50%;\n  background-color: #eee;\n  margin: 0;\n  overflow: hidden;\n  cursor: ", ";\n  user-select: none;\n\n  &:before {\n    content: \"\";\n    background-color: transparent;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ", ";\n    transition: opacity 0.2s ease-in-out;\n    z-index: 1;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: calc(50% - 25px);\n    left: calc(50% - 25px);\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    border: 5px solid transparent;\n    border-top-color: #333;\n    border-right-color: #333;\n    border-bottom-color: #333;\n    animation: ", " 2s linear infinite;\n    opacity: ", ";\n    transition: opacity 0.2s ease-in-out;\n    z-index: 2;\n  }\n"])), function (_a) {
    var $isLoaded = _a.$isLoaded;
    return ($isLoaded ? "auto" : "25vh");
}, function (_a) {
    var $isZoomed = _a.$isZoomed;
    return ($isZoomed ? "zoom-out" : "zoom-in");
}, function (_a) {
    var $isLoaded = _a.$isLoaded;
    return ($isLoaded ? "0" : "1");
}, rotate, function (_a) {
    var $isLoaded = _a.$isLoaded;
    return ($isLoaded ? "0" : "1");
});
var ErrorText = styled_components_1.default.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  border: 1px solid #f8f8f8;\n  padding: 8px 16px;\n  border-radius: 8px;\n  color: #555;\n"], ["\n  width: 100%;\n  text-align: center;\n  border: 1px solid #f8f8f8;\n  padding: 8px 16px;\n  border-radius: 8px;\n  color: #555;\n"])));
var Img = styled_components_1.default.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  opacity: ", ";\n  display: block;\n"], ["\n  opacity: ", ";\n  display: block;\n"])), function (_a) {
    var $isZoomed = _a.$isZoomed;
    return ($isZoomed ? "0" : "1");
});
function ImageZoom(_a) {
    var _b = _a.zoom, zoom = _b === void 0 ? "200" : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.alt, alt = _d === void 0 ? "This is an imageZoom image" : _d, _e = _a.width, width = _e === void 0 ? "100%" : _e, _f = _a.height, height = _f === void 0 ? "auto" : _f, src = _a.src, id = _a.id, className = _a.className, onError = _a.onError, errorContent = _a.errorContent;
    var _g = (0, react_1.useState)(false), isZoomed = _g[0], setIsZoomed = _g[1];
    var _h = (0, react_1.useState)("50% 50%"), position = _h[0], setPosition = _h[1];
    var figureRef = (0, react_1.useRef)(null);
    var zoomInPosition = (0, useZoomPosition_1.default)(figureRef.current);
    var isTouchEventRef = (0, react_1.useRef)(false);
    (0, usePreventBodyScroll_1.default)(isZoomed, figureRef.current);
    var _j = (0, useImageLoader_1.default)(src, onError), imgData = _j.imgData, error = _j.error, naturalWidth = _j.naturalWidth;
    var calculateZoom = (0, useCalculateZoom_1.default)(zoom, fullWidth, naturalWidth, figureRef.current);
    var toggleZoom = function (e, isTouchEvent, isZoomed, setIsZoomed, setPosition, zoomInPosition) {
        if (isTouchEvent) {
            isTouchEventRef.current = true;
        }
        var newIsZoomed = !isZoomed;
        setIsZoomed(newIsZoomed);
        var newPosition = newIsZoomed ? zoomInPosition(e) : "50% 50%";
        if (newPosition) {
            setPosition(newPosition);
        }
    };
    var updatePosition = function (e, isZoomed, setPosition, zoomInPosition) {
        if (isZoomed) {
            var newPosition = zoomInPosition(e);
            if (newPosition) {
                setPosition(newPosition);
            }
        }
    };
    var handleClick = (0, react_1.useCallback)(function (e) {
        if (isTouchEventRef.current) {
            isTouchEventRef.current = false;
            return;
        }
        toggleZoom(e, false, isZoomed, setIsZoomed, setPosition, zoomInPosition);
    }, [isZoomed, zoomInPosition]);
    var handleTouchStart = (0, react_1.useCallback)(function (e) {
        if (e.touches.length === 1) {
            toggleZoom(e, true, isZoomed, setIsZoomed, setPosition, zoomInPosition);
        }
    }, [isZoomed, zoomInPosition]);
    var handleMove = (0, react_1.useCallback)(function (e) {
        updatePosition(e, isZoomed, setPosition, zoomInPosition);
    }, [isZoomed, zoomInPosition]);
    var handleTouchMove = (0, react_1.useCallback)(function (e) {
        if (e.touches.length === 1) {
            e.preventDefault();
            isTouchEventRef.current = true;
            if (isZoomed) {
                updatePosition(e, isZoomed, setPosition, zoomInPosition);
            }
            else {
                handleTouchStart(e);
            }
        }
    }, [handleTouchStart, isZoomed, zoomInPosition]);
    var handleLeave = (0, react_1.useCallback)(function () {
        isTouchEventRef.current = false;
        setIsZoomed(false);
        setPosition("50% 50%");
    }, []);
    var figureStyle = (0, react_1.useMemo)(function () { return ({
        backgroundImage: "url(".concat(isZoomed && imgData ? imgData : "", ")"),
        backgroundSize: calculateZoom,
        backgroundPosition: position,
    }); }, [isZoomed, imgData, calculateZoom, position]);
    if (error)
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, react_1.isValidElement)(errorContent) ? (errorContent) : ((0, jsx_runtime_1.jsx)(ErrorText, { children: "There was a problem loading your image" })) }));
    var figureClasses = [
        imgData ? "loaded" : "loading",
        isZoomed ? "zoomed" : "fullView",
        className,
    ]
        .filter(Boolean)
        .join(" ");
    return ((0, jsx_runtime_1.jsx)(Figure, __assign({ ref: figureRef, id: id, className: figureClasses, style: figureStyle, onClick: handleClick, onMouseMove: handleMove, onMouseLeave: handleLeave, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleLeave, "$isLoaded": !!imgData, "$isZoomed": isZoomed, role: "button", "aria-label": "Zoomable image: ".concat(alt), tabIndex: 0 }, { children: imgData && ((0, jsx_runtime_1.jsx)(Img, { loading: "lazy", id: "imageZoom", src: imgData, alt: alt, width: width, height: height, "$isZoomed": isZoomed })) })));
}
exports.default = ImageZoom;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
